import './SettingsDoNotDisturb.scss'
import './SettingsSelect.scss'

import React, {Component} from 'react'

import {
  updateDoNotDisturb
} from 'manager/redux/settings'

import {
  DO_NOT_DISTURB
} from 'common/constants'

import {
  labelFor
} from 'common/util/helper'

const SettingsDoNotDisturb = ({dispatch, settings}) => {

  function timeOption(item) {
    return <option key={item.value} value={item.value}>{item.label}</option>
  }

  function handleUpdate(settingName, value) {
    let payload = {}
    payload[settingName] = value
    dispatch(updateDoNotDisturb(payload))
  }

  return (
    <div className="SettingsDoNotDisturb">
      <div className="Settings__label">Do Not Disturb</div>

      <div className="Settings__doc">When Do Not Disturb is activated, Opcity will not send you new lead alerts during
        the selected time range.
      </div>

      <div className="SettingsSelect">
        <div
          onClick={ () => handleUpdate("do_not_disturb_enabled", !settings.do_not_disturb_enabled) }
          className={ "SettingsSelect__item clickable " + (settings.do_not_disturb_enabled ? "SettingsSelect__item--active" : "")}>
          <i className="fa fa-check-square-o"></i>
          <i className="fa fa-square-o __checkbox"></i>
          <span className="SettingsSelect__label">Disable Lead Alerts On Schedule</span>
        </div>
      </div>

      <fieldset disabled={!settings.do_not_disturb_enabled}>
        <div className="Settings__label">Disable From:</div>
        <div className={ "SettingsDoNotDisturb__dropdown " + (settings.do_not_disturb_enabled ? "" : "SettingsDoNotDisturb__dropdown--disabled")}>
          <div className="SettingsDoNotDisturb__dropdown--value"><i className="fa fa-sort"/>{ labelFor(DO_NOT_DISTURB, settings.do_not_disturb_start) }</div>
        </div>
        <select
          name="SettingsDoNotDisturb__from"
          className="SettingsDoNotDisturb__select"
          value={ settings.do_not_disturb_start }
          onChange={ (e) => handleUpdate("do_not_disturb_start", e.target.value)}>
          { DO_NOT_DISTURB.map(timeOption) }
        </select>
        <div className="Settings__label">Until:</div>
        <div className={ "SettingsDoNotDisturb__dropdown " + (settings.do_not_disturb_enabled ? "" : "SettingsDoNotDisturb__dropdown--disabled")}>
          <div className="SettingsDoNotDisturb__dropdown--value"><i className="fa fa-sort"/>{ labelFor(DO_NOT_DISTURB, settings.do_not_disturb_end) }</div>
        </div>
        <select
          name="SettingsDoNotDisturb__to"
          className="SettingsDoNotDisturb__select"
          value={ settings.do_not_disturb_end }
          onChange={ (e) => handleUpdate("do_not_disturb_end", e.target.value)}>
          { DO_NOT_DISTURB.map(timeOption) }
        </select>
      </fieldset>
    </div>
  )
}

export default SettingsDoNotDisturb
